import React from 'react';
// import axios from 'axios';
import PropTypes from 'prop-types';
// import Slider from 'react-slick';
import Link from 'components/Link';
import { dateToStringWithFormat } from 'utils/dateUtils';
import makeRequest from 'utils/makeRequest';
import s from './LiveblogUpdates.scss';

function fetchData(feedUrl, callback, isMobile) {
  makeRequest
    .get(feedUrl, { isMobile }, 'skipfeedengine')
    .catch(err => console.log(err))
    .then(data => {
      if (
        data &&
        data.status === 200 &&
        data.data &&
        typeof callback === 'function'
      ) {
        callback(data.data);
      }
    });
}

class LiveblogUpdates extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    if (
      this.props &&
      this.props.liveblogData &&
      this.props.liveblogData.refreshinterval
    ) {
      this.refreshData();
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return (
  //     nextProps?.liveblogData?.news?.lastupd &&
  //     nextState?.liveblogData?.news?.lastupd &&
  //     nextState?.liveblogData?.news?.lastupd >
  //       nextProps?.liveblogData?.news?.lastupd
  //   );
  // }

  refreshData = () => {
    this.electionWidgetInterval = setInterval(() => {
      fetchData(
        this.props.liveblogData.dataUrl,
        data => {
          if (data && data.data) {
            this.setState({
              liveblogData: {
                news: {
                  items: [...data.data.contents],
                  lbgcount: data.data.totalCount,
                  title: data.title1,
                  lastupd: data.lastupd,
                },
                path: this.props.liveblogData.path,
              },
            });
          }
        },
        this.props.isWapView,
      );
    }, this.props.liveblogData.refreshinterval * 1000);
  };

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  renderStory = () => {
    let { liveblogData = {} } = this.state;
    if (!liveblogData.news) {
      liveblogData = Object.assign({}, this.props.liveblogData);
    }
    const { isWapView, storiesCount, hideContent, ga4Data = null } = this.props;
    const { path, news } = liveblogData;
    const { items } = news;
    return (
      <>
        <div className={`${s.lbheading} lbheading`}>
          {path ? (
            <Link
              to={path}
              data-newga={`click-ElectionWidget#${path}`}
              target="_blank"
              ga4Data={!!ga4Data && ga4Data}
            >
              {news.title}
            </Link>
          ) : (
            <span>{news.title}</span>
          )}
        </div>
        {!isWapView &&
          !hideContent && (
            <div className={s.lbContentscrollcontent}>
              {Array.isArray(items) &&
                items.map(
                  (story, index) =>
                    index < storiesCount ? (
                      <div className={s.lbContent} key={index}>
                        <div className={s.content}>
                          <div className={s.time}>
                            <span>
                              {dateToStringWithFormat(
                                story.timestamp,
                                'HH:mm [(IST)] MMM DD',
                              )}
                            </span>
                          </div>
                          <div className={`${s.text} textGlobal`}>
                            {story.title}
                          </div>
                        </div>
                      </div>
                    ) : null,
                )}
            </div>
          )}
      </>
    );
  };

  render() {
    let { liveblogData = {} } = this.state;
    const { themeClass, themeClass2, liveBlogCapsule = false } = this.props;
    if (!liveblogData.news) {
      liveblogData = Object.assign({}, this.props.liveblogData);
    }
    const { path, news } = liveblogData;
    if (!news || !Array.isArray(news.items)) {
      return null;
    }

    let isLiveblogActive = false;
    if (liveblogData && liveblogData.news.lastupd) {
      isLiveblogActive =
        Date.now() - liveblogData.news.lastupd * 1000 < 1 * 60 * 60 * 1000;
    }

    return (
      <div
        className={`${s.liveblog} ${!isLiveblogActive ? s.LBnotactive : ''} ${
          themeClass ? s.electionTheme : ''
        } ${themeClass2 ? s.usElectionTheme : ''}
         ${this.props.hideBattle ? s.hideBattle : ''}
         ${liveBlogCapsule ? s.blogCapsule : ''}`}
      >
        {isLiveblogActive && (
          <div className={s.blinker}>
            <i className={`${s.liveBtn} ${!liveBlogCapsule ? s.red : ''}`} />
            {!themeClass && !liveBlogCapsule && <span>Live Now</span>}
            {liveBlogCapsule && <span>Live</span>}
          </div>
        )}
        {this.renderStory()}
        <div className={`${s.moreupdate} moreupdate`}>
          <Link
            to={path}
            data-newga={`click-ElectionWidget#${path}`}
            target="_blank"
            ga4Data={this.props.ga4Data}
          >
            {this.props.electionStateName && this.props.electionStateName !== ''
              ? `${
                  this.props.electionStateName === 'Jammu & Kashmir'
                    ? 'J&K'
                    : this.props.electionStateName
                } Election Results Live Updates`
              : `${news.lbgcount} More Updates`}
          </Link>
        </div>
      </div>
    );
  }
}

LiveblogUpdates.propTypes = {
  // themeClass: PropTypes.bool,
  // hideHeader: PropTypes.bool,
  liveBlogCapsule: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  electionStateName: PropTypes.string,
  hideBattle: PropTypes.bool,
};
LiveblogUpdates.defaultProps = {
  // themeClass: false,
  // hideHeader: false,
  liveBlogCapsule: false,
  data: {},
  electionStateName: '',
  hideBattle: false,
};

export default LiveblogUpdates;
